import React from 'react'
// import Footer from 'react-bootstrap/Footer'

const PageFooter = () => {

  return (
    <footer id='footer'>
      <div className='container'>
        <div className='row'>
          <div className='col-sm-4 footer-text'>
            <p>Created By © <a href='https://github.com/NicholasBotorog'>Nicholas</a><a href='https://github.com/justingrant94'>Justin</a></p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default PageFooter